@import "../../themes/stories.globals";

:host {
  display: block;
  background-color: lightpink;
}
section {
  flex-shrink: 1;
  height: 100vh;
  width: 100vw;
  background-color: lightcoral;
}
